module.exports = __webpack_public_path__ + "static/media/vishnya.49ff5c3c.jpg";